import React from 'react';
import Dsy from './dsyui';
import { createComponent } from '@lit-labs/react';

const LitComp = Dsy.components.DsyFooter;

export const DsyFooter = createComponent(
  React,
  'dsy-footer',
  LitComp,
  {},
);
